import { Routes } from '@angular/router';
import { routeConstants, routeParams } from './constants/route-constants';
import { loggedInGuard } from './guards/loggedIn.guard';
import { loggedOutGuard } from './guards/loggedOut.guard';

export const routes: Routes = [
  {
    path: routeConstants.home,
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
    pathMatch: 'full',
    canActivate: [loggedInGuard],
  },
  {
    path: routeConstants.login,
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [loggedOutGuard],
  },
  {
    path: routeConstants.clients,
    loadComponent: () =>
      import('./pages/clients/clients.page').then((m) => m.ClientsPage),
    canActivate: [loggedInGuard],
  },
  {
    path: `${routeConstants.clientDetails}/:${routeParams.clientId}`,
    loadComponent: () =>
      import('./pages/client-details/client-details.page').then(
        (m) => m.ClientDetailsPage
      ),
    canActivate: [loggedInGuard],
  },
  {
    path: `${routeConstants.booking}/:${routeParams.bookingType}/:${routeParams.date}/:${routeParams.clientId}`,
    loadComponent: () =>
      import('./pages/booking/booking.page').then((m) => m.BookingPage),
    canActivate: [loggedInGuard],
  },
  {
    path: `${routeConstants.booking}/:${routeParams.date}/:${routeParams.clientId}`,
    loadComponent: () =>
      import('./pages/booking/booking.page').then((m) => m.BookingPage),
    canActivate: [loggedInGuard],
  },
  {
    path: routeConstants.notFound,
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found.page').then(
        (m) => m.PageNotFoundPage
      ),
  },
  {
    path: `**`,
    redirectTo: routeConstants.notFound,
  },
];
